import * as React from 'react';
import styled, {ThemeProvider} from 'styled-components';
import GlobalStyles from './GlobalStyles';

const StyledPageContainer = styled.div`
    position: relative;
    min-height: 100vh;
    .content-wrap {
        padding-bottom: 196px; // FOOTER 
    }
`
const defaultTheme = {
    header: {
        bg: "#e9e9e9"
    },
    backgroundImage: null,
    backgroundUrl: null
}

export const ABGContainer = ({children, theme}) => {

    const overrideTheme = {...defaultTheme, ...theme}
    return (
        <>
            <GlobalStyles />
            <ThemeProvider theme={overrideTheme}>
                <StyledPageContainer>
                    <div className="content-wrap clearfix">
                        {children}
                    </div>
                </StyledPageContainer>
            </ThemeProvider>
        </>
    )
}; 
 
 
 
